import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as dispositivosActions from 'modules/dispositivos/action';
import { goBack } from 'react-router-redux';
import { Container, Row, Col } from 'reactstrap';
import { Paper, List, ListItem, Avatar, Divider, RaisedButton, FloatingActionButton } from 'material-ui';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Warning from 'material-ui/svg-icons/alert/warning';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import HourglassEmpty from 'material-ui/svg-icons/action/hourglass-empty';

import { green500, yellow600, red500 } from 'material-ui/styles/colors';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';

class DispositivoTask extends Component {
  constructor(props) {
    super(props);
    this.state = { showReloadButton: false };
  }
  componentDidMount() {
    const { dispositivoId } = this.props.params;
    if (!dispositivoId) goBack();
    this.props.getFullDispositivo(dispositivoId);
    setTimeout(() => {
      this.setState({ showReloadButton: true });
    }, 5000);
  }
  handleClosePhotoModal = () => {
    this.props.setState({ photoTaskUrl: false });
  };
  handleReloadTasks = () => {
    const { dispositivoId } = this.props.params;
    this.props.getFullDispositivo(dispositivoId);
  };
  render() {
    const dispositivo = this.props.dispositivo.get('dispositivoActual');
    const photoTaskUrl = this.props.dispositivo.get('photoTaskUrl');
    const tasksCount = dispositivo.has('_dispositivoTask') ? dispositivo.get('_dispositivoTask').size : 0;
    if (!dispositivo || dispositivo.size === 0)
      return (
        <Container>
          <Row>
            <Col md={{ size: 8, offset: 2 }}>
              <Paper>
                <h1 style={{ padding: 30 }}> Cargando...</h1>
              </Paper>
            </Col>
          </Row>
        </Container>
      );
    const showLoadMoreButton = tasksCount !== 0 && tasksCount % 20 === 0;
    return (
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <Paper>
              <Row style={{ paddingTop: 20, paddingBottom: 20, justifyContent: 'center', alignItems: 'center' }}>
                <Col md={4} style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                  <p>
                    <b>Marca:</b> {`${dispositivo.get('marca')}`}{' '}
                  </p>
                  <p>
                    <b>Modelo:</b> {`${dispositivo.get('modelo')}`}{' '}
                  </p>

                  {dispositivo.getIn(['_dispositivoData', 0, 'tipoConexion']) && (
                    <p>
                      <b>Conexión:</b> {`${dispositivo.getIn(['_dispositivoData', 0, 'tipoConexion'])}`}{' '}
                    </p>
                  )}
                  {dispositivo.getIn(['_dispositivoData', 0, 'bateriaEstado']) && (
                    <p>
                      <b>Batería:</b> {`${dispositivo.getIn(['_dispositivoData', 0, 'bateriaEstado'])}`}{' '}
                    </p>
                  )}
                  {dispositivo.getIn(['_dispositivoData', 0, 'velocidad']) !== undefined && (
                    <p>
                      <b>Velocidad:</b> {`${dispositivo.getIn(['_dispositivoData', 0, 'velocidad'])} km/h`}{' '}
                    </p>
                  )}
                </Col>
                <Col md={4} style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                  <h4>
                    <b>Número:</b> #{`${dispositivo.get('numero')}`}{' '}
                  </h4>
                  {dispositivo.getIn(['_dispositivoData', 0, 'bateriaCarga']) !== undefined && (
                    <p>
                      <b>Carga batería:</b> {`${dispositivo.getIn(['_dispositivoData', 0, 'bateriaCarga']).toFixed(0)}%`}{' '}
                    </p>
                  )}
                  {dispositivo.getIn(['_dispositivoData', 0, 'fechaEnviado']) && (
                    <div>
                      <p>
                        <b>Últimos datos recibidos:</b>
                      </p>
                      <p>
                        {`${moment(dispositivo.getIn(['_dispositivoData', 0, 'fechaEnviado'])).fromNow()} (${moment(dispositivo.getIn(['_dispositivoData', 0, 'fechaEnviado'])).format(
                          'HH:mm DD/MM',
                        )})`}
                      </p>
                    </div>
                  )}
                </Col>
                <Col md={4} style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                  <RaisedButton label="Solicitar Foto" onClick={() => this.props.requestAction('takePhoto', dispositivo.get('id'))} />
                  <RaisedButton style={{ marginTop: 10 }} label="Actualizar app" onClick={() => this.props.requestAction('updateApp', dispositivo.get('id'))} />
                  {this.state.showReloadButton && <RaisedButton style={{ marginTop: 10 }} label={<RefreshIcon />} onClick={this.handleReloadTasks} />}
                </Col>
              </Row>
              <Divider style={{ marginBottom: 20 }} />
              {dispositivo.get('_dispositivoTask').map((task, index) => (
                <TaskListItem key={task.get('id')} task={task} getPhotoUrl={this.props.getPhotoUrl} />
              ))}
              {showLoadMoreButton && (
                <Row style={{ justifyContent: 'center', padding: 20 }}>
                  <RaisedButton label="Cargar más" onClick={() => this.props.getMoreTasks(dispositivo.get('id'), tasksCount)} />
                </Row>
              )}
            </Paper>
          </Col>
        </Row>
        {photoTaskUrl && <PhotoDialog photoTaskUrl={photoTaskUrl} handleClose={this.handleClosePhotoModal} />}
      </Container>
    );
  }
}

const TaskListItem = ({ task, getPhotoUrl }) => {
  const fechaEjecutada = task.get('fechaEjecutada') ? moment(task.get('fechaEjecutada')) : null;
  const fechaCreado = task.get('fechaCreado') ? moment(task.get('fechaCreado')) : null;
  const esMenosDeUnaHoraEjecutada = fechaEjecutada ? moment().diff(fechaEjecutada, 'hours') < 1 : false;
  const esMenosDeUnaHoraCreado = fechaCreado ? moment().diff(fechaCreado, 'hours') < 1 : false;
  const fechaFormateadaEjecutada = fechaEjecutada && fechaEjecutada.format('HH:mm DD/MM');
  const fechaFormateadaCreado = fechaCreado && fechaCreado.format('HH:mm DD/MM');
  const textoFechaEjecutada = esMenosDeUnaHoraEjecutada ? `${fechaFormateadaEjecutada} (${fechaEjecutada.fromNow()})` : fechaFormateadaEjecutada;
  const textoFechaCreado = esMenosDeUnaHoraCreado ? `${fechaFormateadaCreado} (${fechaCreado.fromNow()})` : fechaFormateadaCreado;
  const executeAtLocation = task.get('executeAtLocation');
  const status = task.get('status');
  const result = task.get('result');
  const filePath = result ? result.get('filePath') : null;
  let icon, iconColor, secondaryText;

  secondaryText = !fechaEjecutada ? `Fecha Creada: ${textoFechaCreado}` : `Fecha Realizada: ${textoFechaEjecutada}`;
  if (executeAtLocation) secondaryText = 'Programada para ejecutar en localización - ' + secondaryText;
  switch (status) {
    case 'success':
      icon = <CheckCircle />;
      iconColor = green500;
      break;
    case 'rejected':
    case 'error':
      icon = <Warning />;
      iconColor = red500;
      console.error(`Task Type: ${task.get('task')}, ID: ${task.get('id')}, Result:`, JSON.stringify(result, null, 2));
      break;
    case 'waiting':
    default:
      icon = <HourglassEmpty />;
      iconColor = yellow600;
      break;
  }

  return (
    <ListItem
      leftAvatar={<Avatar icon={icon} backgroundColor={iconColor} />}
      primaryText={`Tarea: ${task.get('task')}`}
      secondaryText={secondaryText}
      disabled
      rightAvatar={filePath ? <RaisedButton label="Ver Foto" onClick={() => getPhotoUrl(task.get('id'))} /> : null}
    />
  );
};

class PhotoDialog extends Component {
  state = {
    imageLoaded: false,
  };

  handleImageLoaded = () => {
    this.setState({ imageLoaded: true });
  };

  render() {
    const { photoTaskUrl, handleClose } = this.props;
    const { imageLoaded } = this.state;

    return (
      <Dialog modal={false} autoScrollBodyContent={true} open={Boolean(photoTaskUrl)} onRequestClose={handleClose} bodyStyle={{ padding: 0 }}>
        {!imageLoaded && <h1 style={{ textAlign: 'center' }}>Cargando...</h1>}
        <img src={photoTaskUrl} alt="Task" style={{ width: '100%', height: '100%', display: imageLoaded ? 'block' : 'none' }} onLoad={this.handleImageLoaded} />
      </Dialog>
    );
  }
}

const mapStateToProps = (store) => ({
  dispositivo: store.get('dispositivos'),
});

const mapDispatchToProps = (dispatch) => ({
  getFullDispositivo: (dispositivoId) => dispatch(dispositivosActions.getFullDispositivo(dispositivoId)),
  getMoreTasks: (dispositivoId, count) => dispatch(dispositivosActions.getMoreTasks(dispositivoId, count)),
  getPhotoUrl: (taskId) => dispatch(dispositivosActions.getPhotoUrl(taskId)),
  setState: (state) => dispatch(dispositivosActions.setState(state)),
  requestAction: (action, dispositivoId) => dispatch(dispositivosActions.requestAction(action, dispositivoId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DispositivoTask);



// WEBPACK FOOTER //
// src/modules/dispositivos/components/tasks.js